import { useTeamStore } from "../stores/useTeamStore";
import { InfiniteScrollList } from "../components/core/InfiniteScrollList";
import { TeamMemberCard } from "../components/list-cards/team/TeamMemberCard";
import { TeamMemberCardSkeleton } from "../components/list-cards/team/TeamMemberCardSkeleton";
import { useTranslation } from "react-i18next";
import { teamApi } from "../api/team.api";
import { Title } from "@/components/core/Title";
import { PageContainer } from "@/components/core/PageContainer";
import { useNavigate } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TEAM_TEMPLATES } from "@/consts/team.consts";
import { SUPPORT_ACCORDION_SECTIONS } from "@/consts/support.consts";

export function Team() {
  const { t } = useTranslation();
  const store = useTeamStore();
  const navigate = useNavigate();

  const handleAddMember = () => {
    navigate("/support", {
      state: {
        initialFormState: {
          description: TEAM_TEMPLATES.ADD_MEMBER,
        },
        expandAccordion: SUPPORT_ACCORDION_SECTIONS.REPORT_ISSUE,
      },
    });
  };

  return (
    <PageContainer asList>
      <Title 
        refreshAction={() => store.refresh()}
        actionButton={
          <Button variant="link" onClick={handleAddMember} className="align-middle">
            <UserPlus className="h-4 w-4" />
            {t("team.addMember")}
          </Button>
        }
      >
        {t("team.title")}
      </Title>

      <div className="flex-1 min-h-0">
        <InfiniteScrollList
          store={store}
          renderItem={TeamMemberCard}
          renderSkeleton={TeamMemberCardSkeleton}
          queryKey={["team"]}
          queryFn={teamApi.fetchTeam}
          emptyState={{
            image: "/images/empty-states/teams-empty-state.svg",
            title: t("team.emptyState.title"),
          }}
        />
      </div>
    </PageContainer>
  );
}
